"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setCustomProgram = exports.setPredefinedProgram = exports.getCurrentProgram = exports.getSystemSetting = exports.decodeCustomProgram = exports.decodeSystemSetting = exports.decodeStopStimulation = exports.decodePredefinedProgram = exports.decodeStimulationCounter = exports.decodeBatteryLevel = exports.decodeInvertedUint16BitData = void 0;
const ble_utils_1 = require("./ble-utils");
const c = __importStar(require("./constants"));
//DECODING
function decodeInvertedUint16BitData(samples) {
    const samples16Bit = [];
    samples16Bit.push((samples[1] << 8) | samples[0]);
    return samples16Bit;
}
exports.decodeInvertedUint16BitData = decodeInvertedUint16BitData;
function decodeBatteryLevel(data) {
    if (data.byteLength === 2) {
        const batteryLevel = new Uint8Array(data.buffer)[1];
        return batteryLevel;
    }
    return null;
}
exports.decodeBatteryLevel = decodeBatteryLevel;
function decodeStimulationCounter(data) {
    if (data.byteLength === 3 && new Uint8Array(data.buffer)[0] === 15) {
        const stimulationCounter = decodeInvertedUint16BitData(new Uint8Array(data.buffer).subarray(1));
        return stimulationCounter;
    }
    return null;
}
exports.decodeStimulationCounter = decodeStimulationCounter;
function decodePredefinedProgram(data) {
    if (data.byteLength === 3 && new Uint8Array(data.buffer)[0] === 0) {
        const program = new Uint8Array(data.buffer)[1];
        const duration = new Uint8Array(data.buffer)[2];
        return {
            program: program,
            duration: duration,
        };
    }
    return null;
}
exports.decodePredefinedProgram = decodePredefinedProgram;
function decodeStopStimulation(data) {
    if (data.byteLength === 14) {
        const program = new Uint8Array(data.buffer)[1];
        const duration = new Uint8Array(data.buffer)[3];
        const interrupted = new Uint8Array(data.buffer)[7];
        return {
            program: program,
            duration: duration,
            interrupted: interrupted,
        };
    }
    return null;
}
exports.decodeStopStimulation = decodeStopStimulation;
function decodeSystemSetting(data) {
    if (data.byteLength === 16) {
        const batteryLevel = new Uint8Array(data.buffer)[1];
        const vibra = new Uint8Array(data.buffer)[9];
        const light = new Uint8Array(data.buffer)[10];
        const stimulationStatus = new Uint8Array(data.buffer)[11];
        return {
            batteryLevel: batteryLevel,
            vibra: vibra,
            light: light,
            stimulationStatus: stimulationStatus,
        };
    }
    return null;
}
exports.decodeSystemSetting = decodeSystemSetting;
function decodeCustomProgram(data) {
    if (data.byteLength === 6) {
        const intensity = new Uint8Array(data.buffer)[2] & 0x0f;
        const coil = new Uint8Array(data.buffer)[2] >> 4;
        const frequency = new Uint8Array(data.buffer)[3];
        const duration = ble_utils_1.decodeUint16BitData(new Uint8Array(data.buffer).subarray(4, 6))[0];
        return {
            intensity: intensity,
            coil: coil,
            frequency: frequency,
            duration: duration,
        };
    }
    return null;
}
exports.decodeCustomProgram = decodeCustomProgram;
//ENCODING
function getSystemSetting() {
    const systemSetting = new DataView(new ArrayBuffer(1), 0);
    systemSetting.setUint8(0, 7);
    return systemSetting;
}
exports.getSystemSetting = getSystemSetting;
function getCurrentProgram() {
    const currentProgram = new DataView(new ArrayBuffer(1), 0);
    currentProgram.setUint8(0, 25);
    return currentProgram;
}
exports.getCurrentProgram = getCurrentProgram;
function setPredefinedProgram(program) {
    if (program.duration === 1) {
        console.log('SHAM');
        // return null
    }
    else if (program.duration < 10 || program.duration > 720 || program.duration % 10 != 0) {
        console.log('Duration is not accepted. The duration cannot be set below 10 or above 720 minutes. Furthermore, it must be a multiple of 10.');
        return null;
    }
    if (program.program < 0 || program.program > 7 || program.program == 4) {
        console.log('Invalid program');
        return null;
    }
    const programData = new DataView(new ArrayBuffer(2), 0);
    const durationData = new DataView(new ArrayBuffer(2), 0);
    const endData = new DataView(new ArrayBuffer(1), 0);
    durationData.setUint8(0, 1);
    durationData.setUint8(1, program.duration);
    endData.setUint8(0, 25);
    switch (program.program) {
        case c.NEORHYTHM_ENHANCE_MENTAL_CAPACITY:
            programData.setUint8(1, 0);
            break;
        case c.NEORHYTHM_ENERGY_AND_VITALITY:
            programData.setUint8(1, 1);
            break;
        case c.NEORHYTHM_DEEP_RELAXATION:
            programData.setUint8(1, 2);
            break;
        case c.NEORHYTHM_IMPROVE_SLEEP:
            programData.setUint8(1, 3);
            break;
        case c.NEORHYTHM_PAIN_CONTROL:
            programData.setUint8(1, 5);
            break;
        case c.NEORHYTHM_MEDITATION_THETA:
            programData.setUint8(1, 6);
            break;
        case c.NEORHYTHM_MEDITATION_CALM_SYNCHRONIZATION:
            programData.setUint8(1, 7);
            break;
    }
    return {
        programDataView: programData,
        durationDataView: durationData,
        endDataView: endData,
    };
}
exports.setPredefinedProgram = setPredefinedProgram;
function setCustomProgram(program) {
    if (program.intensity != 1 && program.intensity != 2 && program.intensity != 3) {
        console.log('Intensity value is not accepted. The intensity value must be 1 (2.5mT), 2 (0.5mT) or 3 (0.25mT).');
        return null;
    }
    if (program.coil != 1 && program.coil != 2 && program.coil != 3) {
        console.log('Coil value is not accepted. The coil value must be 1 (Front), 2 (L&R) or 3 (All).');
        return null;
    }
    if ((program.intensity == 2 && program.coil != 3) || (program.intensity == 3 && program.coil != 3)) {
        console.log('If an intensity of 0.5mT or 0.25mT, all Coils must be selected.');
        return null;
    }
    if (program.frequency < 0 || program.frequency > 24) {
        console.log('Frequency value is not accepted.');
        return null;
    }
    if (program.duration < 10 || program.duration > 720 || program.duration % 10 != 0) {
        console.log('Duration is not accepted. The duration cannot be set below 10 or above 720 minutes. Furthermore, it must be a multiple of 10.');
        return null;
    }
    const programData = new DataView(new ArrayBuffer(6), 0);
    const endData = new DataView(new ArrayBuffer(1), 0);
    programData.setUint8(1, 10);
    programData.setUint8(2, (program.intensity << 4) | program.coil);
    programData.setUint8(3, program.frequency);
    programData.setUint8(5, program.duration);
    endData.setUint8(0, 25);
    return {
        programDataView: programData,
        endDataView: endData,
    };
}
exports.setCustomProgram = setCustomProgram;
//# sourceMappingURL=neorhythm-utils.js.map